export const FUND_TRANSFER_SET_INTERNAL_BALANCE = 'FUND_TRANSFER:INTERNAL_BALANCE:SET';
export const FUND_TRANSFER_SET_EXTERNAL_BALANCE = 'FUND_TRANSFER:EXTERNAL_BALANCE:SET';

export const setInternalBalance = (internalBalance) => ({
    type: FUND_TRANSFER_SET_INTERNAL_BALANCE,
    payload: internalBalance
});

export const setExternalBalance = (externalBalance) => ({
    type: FUND_TRANSFER_SET_EXTERNAL_BALANCE,
    payload: externalBalance
});
